import { Button } from "@/components/ui/button";
import { ArrowRight, Phone } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_med-transcribe-4/artifacts/hi10en9r_ChatGPT%20Image%20Feb%208%2C%202026%2C%2008_43_59%20PM.png";

const FinalCTASection = ({ onScheduleDemo, onContactUs }) => {
  return (
    <section 
      data-testid="final-cta-section"
      className="py-16 sm:py-24 md:py-32 bg-[#050505] relative overflow-hidden"
    >
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] sm:w-[600px] h-[400px] sm:h-[600px] bg-cyan-500/10 blur-[100px] sm:blur-[150px] rounded-full pointer-events-none" />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 md:px-12 text-center relative z-10">
        {/* Main Content */}
        <div className="mb-8 sm:mb-10">
          <h2 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 px-4">
            Let Us Handle the Documentation
          </h2>
          <p className="text-lg sm:text-xl text-slate-400 mb-4">
            So you can focus on what matters most — <span className="text-cyan-400">your patients</span>.
          </p>
        </div>

        {/* Logo & Brand */}
        <div className="mb-8 sm:mb-10">
          <img 
            src={LOGO_URL} 
            alt="MedinoteX" 
            className="h-10 sm:h-12 w-auto mx-auto mb-3"
          />
          <p className="text-base sm:text-lg text-slate-500 italic">
            Document Less. Care More.
          </p>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center px-4">
          <Button
            onClick={onContactUs}
            data-testid="cta-contact-btn"
            className="btn-secondary h-12 sm:h-14 px-6 sm:px-8 text-base sm:text-lg"
          >
            <Phone className="w-4 h-4 sm:w-5 sm:h-5 mr-2" />
            Contact Us
          </Button>
          <Button
            onClick={onScheduleDemo}
            data-testid="cta-demo-btn"
            className="btn-primary h-12 sm:h-14 px-6 sm:px-8 text-base sm:text-lg group"
          >
            Schedule a Demo
            <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 ml-2 group-hover:translate-x-1 transition-transform" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;
